import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { TabComponent } from "./tab/tab.component";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'psc-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['tabs.component.scss'],
})
export class TabsComponent implements AfterContentInit {
  /**
   * Puts current tab name into query params and allows reading from query params what tab to open.
   * Tabs need to have a name for this to work!
   */
  @Input() tabsControlFromQueryParams: boolean = false;

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngAfterContentInit() {
    const selectedTabName = this.activatedRoute.snapshot.queryParams['tab'];
    this.activatedRoute.queryParams.subscribe((params) => {
      const tabName = params['tab'];
      if (tabName) {
        this.selectTabFromName(tabName);
      }
    });
    if (this.tabsControlFromQueryParams && selectedTabName) {
      this.selectTabFromName(selectedTabName);
    }

    const activeTabs = this.tabs.filter(tab => tab.active);
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  selectTabFromName(name: string) {
    const selectedTab = this.selectedTab(name);
    const currentTab = this.activeTab();
    if (selectedTab && currentTab?.name !== selectedTab.name) {
      this.selectTab(selectedTab);
    }
  }

  selectedTab(name: string) {
    return this.tabs.toArray().find(tab => tab.name === name);
  }

  activeTab() {
    return this.tabs.toArray().find(tab => tab.active);
  }

  selectTab(tab: TabComponent) {
    this.tabs.toArray().forEach(tab => (tab.active = false));
    tab.active = true;

    if (this.tabsControlFromQueryParams && tab.name) {
      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: { tab: tab.name },
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        },
      );
    }
  }
}
